export default {
    page_title: "Kevi | Contact Base",
    base_name: "Contact Base",
    export: "Export",
    create_segment: "Create segment",
    add_contact: "Add Contact",
    import: "Import",
    import_question: "What information do you want to import?",
    sales: "Sales",
    clients: "Clients",
    columns: {
        name: "Name",
        phone: "Phone",
        birthday: "Birthday",
        average_ticket: "Average Ticket",
        spent: "Spent",
        orders_made: "Orders Made",
        email: "Email",
        id: "ID",
        external_id: "External ID",
    },
    open_contact_aria: "Open contact {0} {1}",
    years_old: "years old",
    not_informed: "Not provided",
    details: "Details",
    filters: {
        bought_in_period: "Purchased in period",
        registration_date: "Registration date",
        search: "Name, phone, email or code",
        client_segment: "Client segment",
        first_order_period: "First order period",
    },
    empty_state: {
        title: "Contact Base",
        subtitle: "You do not have any registered clients yet",
    },
    export_headers: {
        name: "Name",
        phone: "Phone",
        birthday: "Birthday",
        age: "Age",
        email: "Email",
        average_ticket: "Average Ticket (R$)",
        spent: "Spent (R$)",
        orders_made: "Orders Made",
        id: "Id",
        external_id: "External Id",
    },
    detail: {
        confirm_delete_order_title: "Are you sure you want to delete the Order?",
        confirm_delete_custom_event_title:
            "Are you sure you want to delete the Custom Event",
        confirm_delete_event_body:
            "This event will be removed as soon as it is confirmed.",
        edit_order: "Edit Order",
        made_order_of: "Placed an order of",
        register_order: "Register Order",
        back: "Back",
        more_segments: "{0} more",
        see_less: "see less",
        insights: "Insights",
        integration_id: "Integration ID:",
        subscribed: "Subscribed:",
        sms: "SMS",
        whatsapp: "WhatsApp",
        total_quotations: "Number of Quotations :",
        total_points: "Total Points :",
        total_orders: "Number of purchases:",
        average_ticket: "Average Ticket:",
        clv: "Accumulated Spend (CLV):",
        next_order_prediction: "Next purchase prediction:",
        replenishment: "Replenishment ({0}):",
        view_one_opinion: "View 1 review.",
        view_many_opinions: "View {0} reviews.",
        edit: "Edit",
        timeline: "Timeline",
        notes: "Notes",
        page_title: "Kevi | Client Detail",
        phonetrack_call: "Call via phonetrack",
        audio_not_supported_prefix:
            "Your browser does not support the",
        utm_source: "Utm source:",
        utm_medium: "Utm medium:",
        utm_campaign: "Utm campaign:",
        gclid: "Gclid:",
        campaign_interaction: "Interacted with campaign",
        left_feedback: "Left feedback",
        with_average: "with average",
        using_form: "Using the form:",
        redeemed_bonus_of: "Redeemed the bonus of",
        exchanged: "Exchanged",
        for: "for",
        left_segment: "Left the",
        entered_segment: "Entered the",
        segment: "segment",
        added: "We added",
        removed: "We removed",
        automation: "Automation:",
        generated_coupon_for: "Generated coupon for",
        code: "code",
        delivery: "Delivery",
        order_cancelled: "Order cancelled",
        status: "Status:",
        products: "Products:",
        earned: "Earned:",
        send_now: "Send Now",
        status_failed: "Sending failed",
        status_failed_with_period: "Sending failed.",
        status_scheduled: "Scheduled",
        status_processing: "Processing",
        status_accepted: "Accepted",
        status_sent: "Sent",
        reason: "Reason:",
        quotation_status_expired: "Expired",
        quotation_status_rejected: "Rejected",
        loading_preview: "Loading preview...",
        registered_event: "registered the event",
        branch: "Branch:",
        task_completed: "Task completed",
        due_date: "Due Date:",
        suggested_message: "Suggested message:",
        created_task: "Created the task",
        quotation: "Quotation",
        has_quotation_of: "Has a quotation of",
        order_placed_on: "Order placed on",
        add_note_placeholder: "Add note...",
        add: "Add",
        in_a: "in a",
        opinion: "review",
        delete_client_title: "Do you want to delete this client?",
        delete_client_body:
            "This action is irreversible and will permanently delete this client and all data linked to them.",
        delete_client_button: "Delete Client",
        notification_sent_success: "Notification sent successfully",
        notification_send_error_prefix: "Error sending notification: ",
        unknown_error: "Unknown error",
        fail_reason_not_subscribed: "Client not subscribed",
        fail_reason_not_enough_credits: "Not enough credits",
        client_deleted_success: "Client deleted successfully!",
        client_delete_error: "Error deleting client.",
        point_singular: " point",
        point_plural: " points",
        ai_error: "Error obtaining AI response.",
        not_found: "Not found",
        storage_load_error: "Could not load group state from localStorage",
        storage_save_error: "Could not save group state to localStorage",
    },
    deletion: {
        started: "Client deletion started!",
        error: "Error starting client deletion",
    },
    basic: {
        subscribed_channels: "Subscribed channels",
        close: "Close",
        save: "Save",
        first_name: "First name",
        last_name: "Last name",
        birthdate: "Birthdate",
        register_event: "Register event",
        run_manual_automation: "Fire automation",
        create_task: "Create task",
        include_orders: "Add Orders",
        create_single_form_link: "Create Single Form Link",
        manage_points: "Add/Remove Points",
        segments: "Segments",
        see_more: "See more",
        search: "Search",
        total_segments: "Total segments: {0}",
        delete: "Delete",
    },
    manual_automation: {
        title: "Fire automation",
        automation_label: "Which automation?",
        automation_placeholder: "Select the automation",
        date_placeholder: "Select the date",
        empty: "No active manual trigger automation.",
        cancel: "Cancel",
        confirm: "Fire",
        success: "Automation fired successfully.",
        error: "The automation could not be fired.",
    },
    modals: {
        delete_client_title: "Delete Client",
        delete_info_irreversible: "Deleting the client from the base is an irreversible action.",
        delete_info_will_delete: "Along with the client we will delete:",
        delete_info_all_sales: "All their sales",
        delete_info_all_tasks: "All their tasks",
        delete_info_all_messages: "All sent messages",
        delete_info_all_records: "Any record linked to this client",
        delete_info_permanent: "This deletion is permanent.",
        delete_info_inconsistency: "Deleting the client can cause data inconsistencies",
        delete_info_inconsistency_detail: ", once you delete the client, Kevi reports will no longer reflect the same numbers as your ERP.",
        delete_info_confirm_phrase_placeholder: "DELETE {0} PERMANENTLY",
        delete_client_confirm: "Are you sure you want to delete this client?",
        delete_client_body: "All data for this client will be permanently removed. This action cannot be undone.",
        delete_client_button: "Delete",
        client_updated_success: "Client updated successfully!",
        client_updated_error: "Error updating client.",
        manage_points: "Add/Remove points",
        current_value: "Current Value:",
        changed_value: "Changed value:",
        close: "Close",
        apply: "Apply",
        create_single_form_link: "Create Single Form Link",
        generated_link: "Generated Link",
        form: "Form",
        select_form: "Select the form",
        generate_link: "Generate Link",
        create_task_title: "Create a Task",
        title: "Title",
        task_title_placeholder: "Give this task a title",
        client: "Client",
        assignee: "Assignee",
        select_assignee: "Select an assignee",
        due_date: "Due date",
        select_due_date: "Select a due date",
        description: "Description",
        task_description_placeholder: "Describe this task",
        cancel: "Cancel",
        create_task_action: "Create task",
        edit_data: "Edit Data",
        new_contact: "New Contact",
        create_contact: "Create Contact",
        subscriptions: "Send Channels",
        main_info: "Main Information",
        integration_id: "Integration ID",
        first_name: "First name",
        mobile: "Mobile",
        birthdate_placeholder: "dd/mm/yyyy",
        client_created_success: "Contact created successfully!",
        client_updated_success: "Contact updated successfully!",
    },
    timeline: {
        search: "Search",
        open_all: "Open all",
        close_all: "Close all",
        showing_range: "Showing {0}-{1} of {2}",
        delete: "Delete",
        order_created: "Order placed",
        order_fields: "Order Fields:",
        order_created_label: "Order placed:",
        email_subject: "Subject:",
        whatsapp_message: "message via WhatsApp",
        sms_message: "message via SMS",
        rcs_message: "message via RCS",
        visited_site_from: "Visited the site from",
        ad: "an ad",
        generated_coupon: "Generated coupon",
        with_code: "with code",
        earned_points: "Earned",
        lost_points: "Lost",
        ai_basic: "Basic",
        ai_advanced: "Advanced",
        ai_generated_content: "AI generated content",
        view_execution_details: "View execution details",
        instruction: "Instruction:",
        tool_calls: "Tool calls ({0})",
        arguments: "Arguments:",
        result: "Result:",
        unknown_event: "Unknown event:",
        field_update_failed: "Failed to update customer fields",
        field_update_failed_reason: "Reason:",
        empty_title: "No events found",
        empty_subtitle:
            "No interactions were recorded for this client with the current filters.",
        waiting: "Waiting",
        scheduled_feminine: "Scheduled",
        failed_of: "Failed to",
        received: "Received",
        pending: "Pending",
        sent_to_another_contact: "Sent to",
        sent_to_another_contact_help:
            "This notification was sent to a contact other than this client's phone or email on file.",
    },
    insights: {
        ai_title: "Kevi AI in your service",
        ai_subtitle:
            "Ask for summaries, understand the client's sentiment, and receive response suggestions in real time.",
        type_message: "Type your message here",
        send: "Send",
        purchases: "Purchases",
        first_purchase: "First purchase",
        last_purchase: "Last purchase",
        most_purchased_item: "Most purchased item",
        cumulative_spend: "Cumulative spend",
        total_purchases: "Total purchases",
        replenishment: "Replenishment",
        replenishment_overdue: "{0} days ago",
        replenishment_today: "Today",
        replenishment_tomorrow: "Tomorrow",
        replenishment_in_days: "In {0} days",
        validity_range: "Validity between: {0} to {1}",
        periods: {
            "30_days": "30 days",
            "90_days": "90 days",
            "180_days": "180 days",
            "1_year": "1 year",
            "all_time": "All time",
        },
        view_all: "View all",
        view_latest: "View latest",
        with_stock: "In stock",
        without_stock: "Out of stock",
        communications: "Communications",
        contacts: "Contacts",
        last_contact_date: "Date of last contact",
        first_contact_date: "Date of first contact",
        points: "Points",
        available_points: "Available points",
        total_accumulated: "Total accumulated",
        points_used: "Points used",
        reward: "Reward",
        forms: "Responses",
        create_unique_link: "Create unique link",
        latest_forms: "Latest responses",
        view: "View",
        answered: "Answered",
        not_answered: "Not Answered",
        no_forms_sent: "No responses",
        no_forms_sent_subtitle:
            "When the customer submits a form, the response appears here. You can also create a unique link.",
        tasks: "Tasks",
        generated: "Generated",
        completed: "Completed",
        conversion: "Conversion",
        completed_on_time: "Completed on time",
        latest_tasks: "Latest tasks",
        completed_single: "Completed",
        pending_single: "Pending",
        kevi_coupons: "Kevi Coupons",
        active_coupons: "Active coupons",
        used_coupons: "Used coupons",
        expired_coupons: "Expired coupons",
        latest_coupons: "Latest coupons",
        added: "Added",
        removed: "Removed",
        used: "Used",
        expired: "Expired",
        available: "Available",
        pending_plural: "Pending",
        completed_plural: "Completed",
    },
    journey: {
        back: "Back",
        title: "Customer Journey",
        move_to_which_board: "To which board do you want to move?",
        move_to_which_stage: "Move to which stage?",
        cancel: "Cancel",
        enter: "Enter",
        move_success: "Client moved successfully",
        outside_journey: "Outside Journey: {0}",
        move_action: "Move {0}",
        move_to_action: "Move {0} to {1}",
        move_completed_success: "Move completed successfully!",
    },
    leads: {
        title: "Leads",
        add: "Add",
        no_leads_found: "No leads found",
        page_title: "Kevi | Leads List",
    },
    importer: {
        sending_data: "Sending data, this may take a few minutes...",
        import_success: "Import completed successfully!",
        import_error: "An error occurred while processing the import.",
        queued_message: "Import submitted! It will be processed in the background.",
        queued_link: "Track it in the import history",
        cancel: "Cancel",
        import: "Import",
        close: "Close",
        file_size_error: "The file exceeds the maximum size of {0} KB.",
    },
    notes: {
        add_note: "Add note",
        markdown_hint: "Use Markdown to format your text.",
        note_placeholder: "Type your note",
        save_note: "Save note",
        client_notes: "Client notes",
        no_notes: "No notes yet",
        no_notes_subtitle: "Register important information about the client to facilitate future service.",
        create_first_note: "Create first note",
        save_error: "Error saving: {0}",
    },
};
